import React from 'react'
import Header from '../../component/Header'
import CertificateinSoftwareArchitect from '../CertificateinSoftwareArchitect'
import Footer from '../../component/Footer'

export default function LayoutCertificateinSoftwareArchitect() {
    return (
        <div>
            <Header />
            <CertificateinSoftwareArchitect />
            <Footer />
        </div>
    )
}
